import React from "react";
import "./touch.css";
import { Link } from "react-router-dom";

const Touch = () => {
  return (
    <>
      <div className="touch-wrapper">
        <div className="container">
          <div className="touch-main">
            <div className="regular-text mobile-text">
              <p>Get in touch</p>
            </div>
            <div className="touch-data">
              <div className="touch-left">
                <div className="regular-text">
                  <p>GM!</p>
                </div>
                <div className="block-title">
                  <h5>
                    Contact <br /> <span className="lightGreen">Swol Sol</span>
                    <br /> for a quote
                  </h5>
                </div>
              </div>
              <div className="touch-right">
                <div className="touch-right-box">
                  <img
                    src="images/touch-right.png"
                    alt="right"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div id="bottom"></div>
            <a href="https://t.me/swolsol" target="_blank" rel="noopener noreferrer">
              <div className="btn pointer">
                <p className="regular-text">Contact via Telegram</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Touch;
